import { queryRequest } from '@library/queryAPI';
import {
  Categories,
  CategoryDetail,
  LegalNotice,
  MenuPermission,
  OptionGroups,
  Products,
  SimpleCategory,
} from '@type/productType';

export const CallGetAuth = (storeID: string) =>
  queryRequest<MenuPermission>({ url: `/biz/stores/${storeID}/menuPermission`, method: 'get' });

export const CallGetCategories = (storeID: string) =>
  queryRequest<Categories[]>({ url: `/biz/stores/${storeID}/categories/extension`, method: 'get' });

export const CallDeleteCategory = (storeID: string, categoryID: string) =>
  queryRequest({ url: `/biz/stores/${storeID}/categories/${categoryID}`, method: 'delete' });

export const CallDeleteMenu = (storeID: string, productsID: string) =>
  queryRequest({ url: `/biz/stores/${storeID}/products/${productsID}`, method: 'delete' });

export const CallGetOptionGroup = (storeID: string) =>
  queryRequest<OptionGroups[]>({ url: `/biz/stores/${storeID}/option-groups`, method: 'get' });

export const CallPostOptionGroup = (storeID: string, param: any) =>
  queryRequest({ url: `/biz/stores/${storeID}/option-groups`, method: 'postJson', data: param });

export const CallDeleteOptGroup = (storeID: string, optGroupID: string) =>
  queryRequest({ url: `/biz/stores/${storeID}/option-groups/${optGroupID}`, method: 'delete' });

export const CallGetOptGroup = (storeID: string, optGroupID: string) =>
  queryRequest({ url: `/biz/stores/${storeID}/option-groups/${optGroupID}`, method: 'get' });

export const CallPutOptGroup = (storeID: string, optGroupID: string, param: any) =>
  queryRequest({ url: `/biz/stores/${storeID}/option-groups/${optGroupID}`, method: 'putJson', data: param });

export const CallDeleteOpt = (storeID: string, optID: string, param: any) =>
  queryRequest({ url: `/biz/stores/${storeID}/option-groups/${optID}`, method: 'putJson', data: param });

export const CallPutOptGroupStatus = (storeID: string, optGroupID: string, param: any) =>
  queryRequest({ url: `/biz/stores/${storeID}/option-groups/${optGroupID}/status`, method: 'put', data: param });

export const CallPutOptDisplay = (storeID: string, optID: string, param: any) =>
  queryRequest({ url: `/biz/stores/${storeID}/options/${optID}/isDisplay`, method: 'putJson', data: param });

export const CallPutOptStatus = (storeID: string, optID: string, status: string) =>
  queryRequest({ url: `/biz/stores/${storeID}/options/${optID}/${status}`, method: 'put' });

export const CallGetLegalNotice = (storeID: string) =>
  queryRequest<LegalNotice>({ url: `/biz/stores/${storeID}/legal-notices`, method: 'get' });

export const CallPostLegalNotice = (storeID: string, param: any) =>
  queryRequest({ url: `/biz/stores/${storeID}/legal-notices`, method: 'post', data: param });

export const CallPostCategories = (storeID: string, param: { categories: CategoryDetail[] }) =>
  queryRequest({ url: `/biz/stores/${storeID}/categories`, method: 'post', data: param });

export const CallGetOptGroupProducts = (storeID: string, optGroupID: string) =>
  queryRequest<LegalNotice>({ url: `/biz/stores/${storeID}/option-groups/${optGroupID}/products`, method: 'get' });

export const CallPutOptUnlick = (storeID: string, optGroupID: string) =>
  queryRequest({ url: `/biz/stores/${storeID}/option-groups/${optGroupID}/unlink/products`, method: 'put' });

export const CallGetProducts = (storeID: string, productID: string) =>
  queryRequest<Products>({ url: `/biz/stores/${storeID}/products/${productID}`, method: 'get' });

export const CallGetAllProducts = (storeID: string) =>
  queryRequest({ url: `/biz/stores/${storeID}/products`, method: 'get' });

export const CallGetTempImageUrl = (file: FormData) =>
  queryRequest<{ returnUrl: string }>({ host: 'upload', url: '/file/upload', method: 'postFile', data: file });

export const CallPostProducts = (storeID: string, param: any) =>
  queryRequest({
    url: `/biz/stores/${storeID}/products`,
    method: 'post',
    data: param,
  });

export const CallPutProductsRecommend = (storeID: string, param: any) =>
  queryRequest({
    url: `/biz/stores/${storeID}/products`,
    method: 'put',
    data: param,
  });

export const CallPutProducts = (storeID: string, productID: string, param: any) =>
  queryRequest({
    url: `/biz/stores/${storeID}/products/${productID}`,
    method: 'put',
    data: param,
  });

export const CallGetProductOptionGroup = (storeID: string, productID: string) =>
  queryRequest<OptionGroups[]>({ url: `/biz/stores/${storeID}/option-groups?productID=${productID}`, method: 'get' });

export const CallPutConnectOptGroup = (storeID: string, optionGroupID: string, productID: string) =>
  queryRequest({
    url: `/biz/stores/${storeID}/option-groups/${optionGroupID}/link/products/${productID}`,
    method: 'put',
  });

export const CallPutUnConnectOptGroup = (storeID: string, optionGroupID: string, productID: string) =>
  queryRequest({
    url: `/biz/stores/${storeID}/option-groups/${optionGroupID}/unlink/products/${productID}`,
    method: 'put',
  });

export const CallPutIsDisplay = (storeID: string, productID: string, param: any) =>
  queryRequest({
    url: `/biz/stores/${storeID}/products/${productID}/isDisplay`,
    method: 'putJson',
    data: param,
  });

export const CallPutSoldout = (
  storeID: string,
  path: 'products' | 'options',
  productID: string,
  type: 'sale' | 'soldout',
) =>
  queryRequest({
    url: `/biz/stores/${storeID}/${path}/${productID}/${type}`,
    method: 'put',
  });

export const CallGetSimpleCategories = (storeID: string) =>
  queryRequest<SimpleCategory[]>({ url: `/stores/${storeID}/categories`, method: 'get' });

export const CallPutSortCategory = (storeID: string, param: { categories: (SimpleCategory | Categories)[] }) =>
  queryRequest({ url: `/biz/stores/${storeID}/category-sort`, method: 'putJson', data: param });

export const CallPutSortOptionGroup = (
  storeID: string,
  productID: string,
  param: {
    optionGroups: {
      ID: number;
      options: { ID: string }[];
    }[];
  },
) => queryRequest({ url: `/biz/stores/${storeID}/products/${productID}/options`, method: 'putJson', data: param });
